/* eslint-disable jira/integration/test-id-by-folder-structure */

import React from 'react';
import Link from '@atlaskit/link/link';
import EmptyState from '@atlaskit/empty-state/empty-state';
import CraneIllustration from '@jira/illustrations__illustrations/src/ui/adg4/jira/spots/other/components/infrastructure-crane/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@jira/illustrations__illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { useIntl, defineMessage } from '@atlassian/jira-intl';

const errorTitle = defineMessage({
	id: 'servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.error-title',
	defaultMessage: 'Be right back',
	description:
		'Error message describing that the Assets functionality is temporarily unavailable and will be back soon',
});

const errorDescription = defineMessage({
	id: 'servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.error-description',
	defaultMessage:
		'Assets is currently under maintenance and will return shortly. <break></break> Please try again later.',
	description:
		'Error description that the Assets feature is currently undergoing maintenance and will be available at a later time',
});

const contactMessage = defineMessage({
	id: 'servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.contact-message',
	defaultMessage: 'Contact support',
	description: 'Link for user to contact customer support',
});

const contactSupportLink = 'https://support.atlassian.com/contact/#/';

export const MaintenanceModePage = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const renderImage = () =>
		getAkEmptyStateRenderImageFn(CraneIllustration)({
			imageWidth: 275,
			maxImageWidth: 275,
			maxImageHeight: 275,
		});

	return (
		<EmptyState
			width="wide"
			renderImage={renderImage}
			header={formatMessage(errorTitle)}
			description={formatMessage(errorDescription, {
				break: () => <br />,
			})}
			primaryAction={
				<Link href={contactSupportLink} target="_blank">
					{formatMessage(contactMessage)}
				</Link>
			}
			testId="cmdb-maintenance-page.ui.cmdb-maintenance-page"
		/>
	);
};
